import { u as ie } from "./widgets-core.es20.js";
import { default as Ue } from "./widgets-core.es20.js";
import { default as He } from "./widgets-core.es18.js";
import { default as Ve } from "./widgets-core.es15.js";
import { _ as Me, a as We, f as Fe, h as Le, c as $e, e as qe, d as ze, i as Je, p as Ye, g as Ae, b as Qe, r as Ze, s as Te } from "./chunks/SetupProvider.vue_vue_type_script_setup_true_lang.C30U5ekn.js";
import { default as er } from "./widgets-core.es4.js";
import { default as ar } from "./widgets-core.es10.js";
import { default as nr } from "./widgets-core.es2.js";
import { default as ir } from "./widgets-core.es3.js";
import { default as ur } from "./widgets-core.es8.js";
import { default as cr } from "./widgets-core.es11.js";
import { default as gr } from "./widgets-core.es12.js";
import { default as pr } from "./widgets-core.es19.js";
import { default as vr, g as mr } from "./widgets-core.es5.js";
import { default as wr } from "./widgets-core.es14.js";
import { default as yr } from "./widgets-core.es16.js";
import { default as xr } from "./widgets-core.es17.js";
import { default as Rr } from "./widgets-core.es9.js";
import { default as Cr } from "./widgets-core.es6.js";
import { default as Ir } from "./widgets-core.es13.js";
import { defineComponent as oe, useSlots as ue, useAttrs as le, openBlock as ce, createBlock as fe, h as ge, onBeforeUnmount as ne, ref as h, computed as p, watch as de } from "vue";
import { u as Pr } from "./chunks/useTheme.Dsjkx8w7.js";
import { r as Or } from "./chunks/key.-LBAiGu1.js";
import { u as jr } from "./chunks/useDevicePosition.CNFcvGt1.js";
import { u as pe } from "./chunks/index.xeoxcFSu.js";
var r;
(function(e) {
  e.Arabic = "ar", e.Basque = "eu", e.Bulgarian = "bg", e.Catalan = "ca", e.Chinese = "zh", e.ChineseTraditional = "zh-TW", e.Croatian = "hr", e.Czech = "cs", e.Danish = "da", e.Deutsch = "de", e.Dutch = "nl", e.English = "en", e.Estonian = "et", e.Finnish = "fi", e.French = "fr", e.Greek = "el", e.Hebrew = "he", e.Hungarian = "hu", e.Icelandic = "is", e.Indonesian = "id", e.Italian = "it", e.Japanese = "ja", e.Korean = "ko", e.Lithuanian = "lt", e.Norwegian = "no", e.Polish = "pl", e.Portuguese = "pt", e.Romanian = "ro", e.Russian = "ru", e.Slovenian = "sl", e.Spanish = "es", e.Swedish = "sv", e.Thai = "th", e.Turkish = "tr", e.Ukrainian = "uk", e.Vietnamese = "vi";
})(r || (r = {}));
var S;
(function(e) {
  e.Timing = "timing", e.Oraculo = "oraculo", e.VisitorProfile = "visitorProfile", e.VisitorBehaviour = "visitorBehaviour", e.Search = "search", e.TravelParty = "travelParty", e.DataVariables = "dataVariables", e.Demand = "demand";
})(S || (S = {}));
var y;
(function(e) {
  e.Exclude = "exclude", e.Include = "include";
})(y || (y = {}));
var _;
(function(e) {
  e.Any = "any", e.Is = "is", e.Are = "are", e.IsBetween = "isBetween", e.AreBetween = "areBetween", e.IsLower = "isLower", e.AreLower = "areLower", e.IsHigher = "isHigher", e.IsGreater = "isGreater", e.AreGreater = "areGreater", e.IsBefore = "isBefore", e.AreBefore = "areBefore", e.IsAfter = "isAfter", e.AreAfter = "areAfter", e.Contain = "contain";
})(_ || (_ = {}));
var x;
(function(e) {
  e.Is = "is", e.IsNot = "isNot", e.AnyValue = "anyValue", e.NotAnyValue = "notAnyValue", e.Lower = "lower", e.Greater = "greater", e.Contains = "contains", e.NotContains = "notContains";
})(x || (x = {}));
var k;
(function(e) {
  e.Registered = "registered", e.NonRegistered = "non_registered", e.RegisteredAndLogged = "registered", e.NotRegisteredAndNotLogged = "non_registered_nor_logged", e.RegisteredOrLogged = "registered_all", e.RegisteredAndNotLogged = "registered_non_logged", e.NotLogged = "non_registered";
})(k || (k = {}));
var R;
(function(e) {
  e.Logged = "logged", e.NonLogged = "nonLogged";
})(R || (R = {}));
var X;
(function(e) {
  e.Any = "any", e.First = "first", e.All = "all", e.Search = "search", e.Booked = "booked", e.Custom = "custom";
})(X || (X = {}));
var C;
(function(e) {
  e.Colors = "colors", e.Fonts = "fonts", e.Button = "button", e.Background = "background", e.Overlay = "overlay";
})(C || (C = {}));
var N;
(function(e) {
  e.None = "none", e.Uppercase = "uppercase", e.Lowercase = "lowercase", e.Titlecase = "titlecase";
})(N || (N = {}));
var I;
(function(e) {
  e.Google = "google", e.File = "file", e.Regular = "regular";
})(I || (I = {}));
var E;
(function(e) {
  e.Custom = "custom", e.Square = "square", e.Medium = "medium", e.Rounded = "rounded";
})(E || (E = {}));
var P;
(function(e) {
  e.Percentage = "%", e.Pixels = "px", e.Rem = "rem", e.Em = "em";
})(P || (P = {}));
var B;
(function(e) {
  e.Solid = "solid", e.Outline = "outline";
})(B || (B = {}));
var O;
(function(e) {
  e.Url = "url", e.DefaultText = "default_text", e.CustomText = "custom_text", e.NotLinked = "not_linked", e.CustomUrl = "custom_url";
})(O || (O = {}));
var U;
(function(e) {
  e.ApplyDiscount = "apply-discount", e.Dismiss = "dismiss", e.Hide = "hide", e.EmptyClick = "empty-click", e.Fallback = "none", e.GenericLinkClick = "generic-link-click", e.LoadScript = "load-script", e.OpenBookingEngine = "open-be", e.OpenUri = "open-uri", e.PredictiveAudience = "predictive-audience", e.SendForm = "send-form", e.SendSaveSearch = "send-save-search", e.SendSiteContact = "send-site-contact", e.SendSubscribe = "send-subscribe", e.Show = "show", e.Login = "login", e.LastSearch = "send-to-last-search";
})(U || (U = {}));
var j;
(function(e) {
  e.Resend = "resend", e.Signup = "signup", e.Signin = "signin", e.Validation = "validation";
})(j || (j = {}));
var l;
(function(e) {
  e.NowViewing = "nowViewing", e.TodayViewed = "todayViewed", e.BookedToday = "bookedToday", e.LastReservation = "lastReservation", e.DiscountToday = "discountToday", e.TodaySpecialOffer = "todaySpecialOffer";
})(l || (l = {}));
var H;
(function(e) {
  e.ApplyPromoCode = "apply_promo_code", e.OpenUrl = "open_url", e.OpenMailClient = "open_mail_client", e.CallPhoneNumber = "call_phone_number", e.CloseTool = "close_tool", e.EmailCapture = "email_capture", e.SavedSearch = "saved_search", e.GoMainStep = "go_main_step", e.SendForm = "form", e.OpenBookingEngine = "send_to_be", e.Submit = "submit", e.LastSearch = "send_to_last_search";
})(H || (H = {}));
var D;
(function(e) {
  e.Default = "default", e.Coupon = "coupon", e.Rate = "rate", e.Corporative = "corpo", e.Group = "group";
})(D || (D = {}));
var V;
(function(e) {
  e.Note = "note", e.Layer = "layer", e.Exit = "exit", e.Inliner = "inliner";
})(V || (V = {}));
var G;
(function(e) {
  e.Success = "success", e.Failure = "failure", e.Main = "main";
})(G || (G = {}));
var M;
(function(e) {
  e.LoginSignin = "login-signin", e.LoginRegister = "login-register", e.LoginSuccess = "login-success";
})(M || (M = {}));
var W;
(function(e) {
  e.Activity = "activity", e.Button = "button", e.Countdown = "countdown", e.EmailCapture = "emailCapture", e.Form = "form", e.Heading = "heading", e.ImageWithBehaviour = "imageWithBehaviour", e.Icon = "icon", e.Paragraph = "paragraph", e.Perks = "perks", e.SavedSearch = "savedSearch", e.Spacer = "spacer", e.Login = "login";
})(W || (W = {}));
var f;
(function(e) {
  e.None = "none", e.WebExclusive = "web_exclusive", e.SubjectToAvailibity = "subject_to_availability", e.OnlyForSpecificRates = "only_for_specific_rates", e.OnlyForRegisterdUsers = "only_for_registered_users";
})(f || (f = {}));
var F;
(function(e) {
  e.Bullets = "bullets", e.Highlights = "highlights";
})(F || (F = {}));
var L;
(function(e) {
  e.None = "none", e.Solid = "solid", e.Outline = "outline";
})(L || (L = {}));
var $;
(function(e) {
  e.Normal = "normal", e.Compact = "compact";
})($ || ($ = {}));
var q;
(function(e) {
  e.Date = "date", e.Time = "time";
})(q || (q = {}));
var z;
(function(e) {
  e.Visitor = "visitor", e.Hotel = "hotel";
})(z || (z = {}));
var J;
(function(e) {
  e.Out = "out", e.Inside = "inside";
})(J || (J = {}));
var Y;
(function(e) {
  e.Single = "single", e.Multiple = "multiple";
})(Y || (Y = {}));
var A;
(function(e) {
  e.ShortText = "shortText", e.Email = "email", e.Phone = "phone", e.Date = "date", e.LongText = "longText", e.DropDown = "dropdown", e.Selection = "selection";
})(A || (A = {}));
var Q;
(function(e) {
  e.Top = "T", e.Bottom = "B", e.Left = "L", e.Right = "R", e.UpperLeft = "UL", e.UpperRight = "UR", e.UpperMidLeft = "UML", e.UpperMidRight = "UMR", e.LowerMidLeft = "LML", e.LowerMidRight = "LMR", e.LowerLeft = "LL", e.LowerRight = "LR";
})(Q || (Q = {}));
var Z;
(function(e) {
  e.Mobile = "mobile", e.Desktop = "desktop";
})(Z || (Z = {}));
var T;
(function(e) {
  e.EveryPage = "on_every_page", e.OncePerVisit = "once_per_visit", e.OncePerVisitor = "once_per_visitor", e.OncePerProperty = "once_per_property", e.OncePerBrand = "once_per_brand";
})(T || (T = {}));
var K;
(function(e) {
  e.Load = "load", e.Scroll = "scroll", e.Idle = "idle";
})(K || (K = {}));
var ee;
(function(e) {
  e.Regular = "regular", e.Compact = "compact";
})(ee || (ee = {}));
var re;
(function(e) {
  e.Single = "single", e.Multi = "multi";
})(re || (re = {}));
var ae;
(function(e) {
  e.Circular = "circular", e.CustomImage = "custom-image", e.Fullscreen = "full-screen", e.FullscreenMini = "full-screen-mini", e.LowerNotification = "lower-notification", e.NotificationTab = "notification-tab", e.Sidebar = "sidebar", e.SideGradient = "side-gradient", e.Square = "square", e.SquareImage = "square-image", e.Sticky = "sticky", e.StickyImage = "sticky-image";
})(ae || (ae = {}));
var te;
(function(e) {
  e.Left = "left", e.Center = "center", e.Right = "right";
})(te || (te = {}));
l.NowViewing + "", l.TodayViewed + "", l.BookedToday + "", l.LastReservation + "", l.DiscountToday + "", l.TodaySpecialOffer + "";
f.None + "", f.SubjectToAvailibity + "", f.WebExclusive + "", f.OnlyForRegisterdUsers + "", f.OnlyForSpecificRates + "";
function ye(e) {
  return {
    [r.Arabic]: "العربية",
    [r.Basque]: "Euskara",
    [r.Bulgarian]: "Български",
    [r.Catalan]: "Català",
    [r.Chinese]: "简体中文",
    [r.ChineseTraditional]: "繁體中文",
    [r.Croatian]: "Hrvatski",
    [r.Czech]: "Čeština",
    [r.Danish]: "Dansk",
    [r.Deutsch]: "Deutsch",
    [r.Dutch]: "Nederlands",
    [r.English]: "English",
    [r.Estonian]: "Eesti",
    [r.Finnish]: "Suomi",
    [r.French]: "Français",
    [r.Greek]: "Ελληνικά",
    [r.Hebrew]: "עברית",
    [r.Hungarian]: "Magyar",
    [r.Icelandic]: "Íslenska",
    [r.Indonesian]: "Indonesia",
    [r.Italian]: "Italiano",
    [r.Japanese]: "日本語",
    [r.Korean]: "한국어",
    [r.Lithuanian]: "Lietuvių",
    [r.Norwegian]: "Norsk",
    [r.Polish]: "Polski",
    [r.Portuguese]: "Português",
    [r.Romanian]: "Română",
    [r.Russian]: "Русский",
    [r.Slovenian]: "Slovenščina",
    [r.Spanish]: "Español",
    [r.Swedish]: "Svenska",
    [r.Thai]: "ไทย",
    [r.Turkish]: "Türkçe",
    [r.Ukrainian]: "Українська",
    [r.Vietnamese]: "Tiếng Việt"
  }[e] ?? "Unknown Language";
}
function he(e) {
  return e.getRootNode() instanceof ShadowRoot;
}
function _e(e) {
  return he(e) ? e.getRootNode().host : null;
}
const xe = /* @__PURE__ */ oe({
  __name: "I18nT",
  props: {
    keypath: {},
    tag: { default: "span" }
  },
  setup(e) {
    const a = e, n = ue(), u = le(), { t: o } = ie(), g = Object.keys(n).sort(
      (i, s) => o(a.keypath).indexOf(`{${i}}`) - o(a.keypath).indexOf(`{${s}}`)
    ), v = g.reduce(
      (i, s, c) => {
        const d = o(a.keypath), m = `{${g[c - 1]}}`, b = `{${s}}`, se = d.indexOf(m) !== -1 ? d.indexOf(m) + m.length : 0, w = d.indexOf(b);
        return i.push(
          d.slice(se, w),
          n[s]()
        ), c === g.length - 1 && i.push(
          d.slice(w + b.length)
        ), i;
      },
      []
    ), t = () => ge(
      a.tag,
      u,
      v
    );
    return (i, s) => (ce(), fe(t));
  }
});
function ke(e) {
  return e ? "rtl" : "ltr";
}
function Re({
  enabled: e,
  delay: a,
  callback: n
}) {
  const u = setTimeout(() => {
    e && a > 0 && n();
  }, a * 1e3), o = () => clearTimeout(u);
  return ne(o), {
    clear: o
  };
}
function Xe() {
  return {
    isHoverCapable: window.matchMedia("(any-hover: hover)").matches
  };
}
function Ce(e) {
  const a = Object.keys(e).reduce((t, i) => {
    const s = {
      dirty: h(!1),
      model: h(e[i].initialValue),
      errorMessage: h(""),
      isValid() {
        let c = 0;
        for (; c < e[i].validation.length; ) {
          if (!e[i].validation[c].validator(s.model.value))
            return s.errorMessage.value = e[i].validation[c].errorMessage, !1;
          c += 1;
        }
        return !0;
      },
      error: p(
        () => s.dirty.value && !s.isValid()
      ),
      success: p(
        () => s.dirty.value && s.isValid()
      )
    };
    return {
      ...t,
      [i]: s
    };
  }, {}), n = {};
  Object.keys(a).forEach((t) => {
    n[t] = de(a[t].model, () => {
      a[t].dirty.value = !0;
    });
  });
  const u = p(
    () => Object.keys(a).every((t) => a[t].isValid())
  ), o = p(
    () => Object.keys(a).some(
      (t) => a[t].dirty.value
    )
  ), g = () => (Object.keys(a).forEach((t) => {
    a[t].dirty.value = !0;
  }), u.value), v = () => {
    Object.keys(a).forEach((t) => {
      a[t].dirty.value = !1, a[t].model.value = e[t].initialValue;
    });
  };
  return ne(() => {
    Object.keys(n).forEach((t) => {
      n[t]();
    });
  }), {
    state: a,
    dirty: o,
    isValid: u,
    validate: g,
    reset: v
  };
}
function Ne({ width: e, widthUnit: a }) {
  return !e || e === "auto" ? "100%" : `${e}${a || "px"}`;
}
const ve = 10, me = 100;
function Ie(e, a) {
  const n = h(0), { lengthY: u, direction: o } = pe(
    e,
    {
      threshold: ve,
      onSwipe() {
        o.value === "down" && (n.value = u.value);
      },
      onSwipeEnd() {
        if (o.value === "down" && Math.abs(u.value) > me) {
          a.onEnd();
          return;
        }
        n.value = 0;
      }
    }
  );
  return { distanceY: n };
}
function Ee(e) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}
function Pe(e) {
  return typeof e == "boolean" ? e : typeof e == "string" ? e.trim() !== "" : typeof e == "number" ? !0 : Array.isArray(e) ? e.length > 0 : typeof e == "object" && e !== null ? Object.keys(e).length > 0 : !1;
}
export {
  Ue as ActionButton,
  pr as ArrowBtn,
  He as Button,
  xr as Clipper,
  yr as Collapse,
  Ve as CustomSelect,
  wr as ErrorMessage,
  Ir as FloatingBox,
  gr as FloatingTrigger,
  cr as FloatingWindow,
  xe as I18nT,
  ar as List,
  Rr as Modal,
  ur as RecordGrid,
  Me as SetupProvider,
  Cr as SwapTab,
  vr as Tooltip,
  er as TruncateList,
  ir as WidgetCheckbox,
  nr as WidgetInput,
  We as arabicPluralRule,
  Fe as asiaticPluralRule,
  Le as colorHelper,
  $e as croatianPluralRule,
  qe as czechPluralRule,
  ze as defaultPluralRule,
  Ee as email,
  ye as getLanguageName,
  mr as getScrollableParent,
  _e as getShadowHost,
  Je as icelandicPluralRule,
  he as isElementInShadowDom,
  Ye as pluralRule,
  Ae as pluralRulesMap,
  Qe as polishPluralRule,
  Or as replaceTokens,
  Pe as required,
  Ze as romanianPluralRule,
  Te as slavicPluralRule,
  Re as useAutoClose,
  Xe as useDeviceFeatures,
  jr as useDevicePosition,
  ie as useI18n,
  Ne as useInlinerWidth,
  Ie as useSwipeDown,
  ke as useTextDirection,
  Pr as useTheme,
  Ce as useValidation
};
//# sourceMappingURL=widgets-core.es.js.map
